import { render, staticRenderFns } from "./Paysheet.vue?vue&type=template&id=56a0f22f&"
import script from "./Paysheet.vue?vue&type=script&lang=js&"
export * from "./Paysheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports